import React, { Fragment } from "react";
import { Badge }  from "reactstrap";
import moment from 'moment'

import DefaultOfferImg from "~/assets/images/default-offer.png";

const CashbackCard = ({item}) => {

  const formatDate = (date)=> moment(date).format("YYYY-MM-DD");

  return (
    <Fragment>
      <img src={item.icon || DefaultOfferImg} />

      <div className="item-details">
        <div>
              <h6> {`Cashback ${item.programName}`}  </h6>
              <Badge color="points">  POINTS: {item.cashbackPoints} </Badge>
        </div>
        <div>
          <h6>  {formatDate(item.updatedAt)} </h6>
          {item.status === 1 && <Badge color="info"> ON HOLD </Badge>}
          {item.status === 2 && <Badge color="custom-completed"> COMPLETED </Badge>}
          {item.status === 3 && <Badge color="custom-reversal"> DECLINED </Badge>}
          
        </div>
      </div>
    </Fragment>
  );
};


export default CashbackCard;
